const sortAlphabetically = (a, b, inverted = false) => {
  if (inverted) {
    return b.name > a.name ? 1 : -1
  }

  return a.name > b.name ? 1 : -1
}

export default sortAlphabetically
